import { useEffect, useState } from "react";
import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { fetchFortNoxPrograms } from "../../actions/programmeActions";

export default function CleanLicense() {
  const dispatch = useDispatch();
  const fortNoxPrograms = useSelector((state) => state.fortnoxProgramReducer);
  const [selectedLicenseId, setSelectedLicenseId] = useState(null);
  const [email, setEmail] = useState("");
  const [emailEmptyError, setEmailEmptyError] = useState(false);
  const [selectedLicenseEmptyError, setSelectedLicenseEmptyError] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchFortNoxPrograms());
  }, [dispatch]);

  const licenseOptions =
    fortNoxPrograms?.result?.map((p) => ({
      value: p.id,
      label: p.licenseName,
    })) ?? [];

  const handleCleanLicense = async () => {
    if (!email) {
      return setEmailEmptyError(true);
    }
    if (!selectedLicenseId) {
      return setSelectedLicenseEmptyError(true);
    }

    setIsSubmitting(true);

    await axios
      .post("/Student/CleanLicense", {
        fortNoxProgramToKeepId: selectedLicenseId,
        studentEmail: email,
      })
      .then((res) => {
        toast.success(res.data.result, TOAST_CONFIG);
      })
      .catch((err) => {
        var failMessage = err?.response?.data ? err.response.data : err;
        toast.warn(failMessage, TOAST_CONFIG);
      });

    setIsSubmitting(false);
  };

  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col xs="3" className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="CleanLicense" />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="clean-license-email"
            placeholder="elevens email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value.trim());
              setEmailEmptyError(false);
            }}
          />
          {emailEmptyError && (
            <div className="text-danger input-feedback">
              <FormattedMessage id="Views.Admin.CreateTeacherForm.Error.RequireEmail" />
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <Select
            name="programLicenses"
            placeholder="Välj den licens som ska behållas"
            noOptionsMessage={() => "Det finns inga valbara licenser"}
            options={licenseOptions}
            onChange={(e) => {
              setSelectedLicenseId(e.value);
              setSelectedLicenseEmptyError(false);
            }}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99 }) }}
          />
          {selectedLicenseEmptyError && (
            <div className="text-danger input-feedback">
              Du måste välja en licens att behålla.
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs="4" className="mb-2 text-danger input-feedback">
          OBS: Övriga licenser kommer att tas bort inklusive resultat för dessa.
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            id="button-clean-license"
            disabled={isSubmitting}
            onClick={handleCleanLicense}
          >
            {isSubmitting ? (
              <FormattedMessage id="Wait" />
            ) : (
              <FormattedMessage id="Clean" />
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
